import { render, staticRenderFns } from "./StatisticInfo.vue?vue&type=template&id=7f4aa463&scoped=true&"
import script from "./StatisticInfo.vue?vue&type=script&lang=js&"
export * from "./StatisticInfo.vue?vue&type=script&lang=js&"
import style0 from "./StatisticInfo.vue?vue&type=style&index=0&id=7f4aa463&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4aa463",
  null
  
)

export default component.exports